import { fetchMeldungsmodiFromStorage, writeMeldungsmodiToStorage } from './meldungsmodusStorageHelpers';
var createInitialState = function () {
    var meldungsmodi = fetchMeldungsmodiFromStorage();
    var initialState = {
        showFlaechen: 'aktiv',
        tanRequesting: false,
        tanValidating: false,
        tanResending: false,
        meldungsmodi: meldungsmodi,
        showFullFilter: false,
    };
    writeMeldungsmodiToStorage(meldungsmodi);
    return initialState;
};
export default createInitialState;
